import * as React from 'react';
import { UIText1, UIText2, Button } from '@cian/ui-kit';

import { SpecificationTooltip } from './parts/SpecificationTooltip';
import * as styles from './Specifications.css';
import { SPECIFICATIONS_ICON_MAP } from '../../constants/specifications';
import { ISpecificationItem } from '../../types/newbuilding/specification';
import { Layout } from '../Layout';

export interface ISpecificationsProps {
  specifications: ISpecificationItem[];
  builderLink: React.ReactNode;
  onClick(): void;
}

export const Specifications: React.FC<ISpecificationsProps> = ({ specifications, builderLink, onClick }) => {
  return (
    <Layout>
      <div className={styles['container']}>
        <div className={styles['specifications']} data-testid="SpecificationList">
          {specifications.map(
            ({ itemType, title, value, tooltipText }) =>
              title && (
                <div key={itemType} className={styles['specification']}>
                  {SPECIFICATIONS_ICON_MAP[itemType]}
                  <div className={styles['text']}>
                    <UIText2 color={'black_60'} data-testid="SpecificationTitle">
                      {title}
                    </UIText2>
                    <div className={styles['value']} data-testid="SpecificationValue">
                      <UIText1 fontWeight={'bold'}>{value || '—'}</UIText1>
                      {tooltipText && <SpecificationTooltip text={tooltipText} />}
                    </div>
                  </div>
                </div>
              ),
          )}
        </div>
        <div className={styles['bottom']}>
          <Button size="M" theme="stroke_primary" onClick={onClick}>
            Все характеристики комплекса
          </Button>
          <div className={styles['builder-link']}>{builderLink}</div>
        </div>
      </div>
    </Layout>
  );
};
